import React, { useContext, useEffect, useState } from 'react';
import AuthHeader from '../../commons/AuthHeader';
import AuthFooter from '../../commons/AuthFooter';
import { Button, ButtonVariant, IconName, ButtonIconAlign, Icon, IconSize } from '@eightfold.ai/octuple';
import { globalContext } from '../../store';
import { launchAssessmentWithStatusUpdate, initialiseImmersiveAssessment } from '../../commons/commonFunctions';
import { useNavigate } from 'react-router-dom';
import { actionButtonStyle, navReturnBtnStyle } from '../../commons/commonStyles';

const PrepStepsCompletion = () => {
  const navigate = useNavigate();
  const { globalState, dispatch } = useContext(globalContext);

  const title = globalState?.clientData?.name;
  const [showLoader, setShowLoader] = useState(false);
  const [, setLeaderName] = useState<any>('');
  const [headerLogo, setHeaderLogo] = useState<string>('');
  const [, setHeaderImage] = useState<string>('');
  const [, setPrimaryColor] = useState<string>('#BA3A19');
  const immersiveAssessData = globalState?.immersiveAssessmentData;
  
  useEffect(() => {
    const params = {globalState, dispatch, navigate, setLeaderName, setHeaderImage, setHeaderLogo, setPrimaryColor, title};
    initialiseImmersiveAssessment(params);
  }, []);

  return (
    <div className='mainWrapper'>
        <div className='innerWrapper'>
          <AuthHeader title={title} headerLogo={headerLogo} setLoader={setShowLoader} />
          <div className='middleWrapper'>
            <div className='leftTextWrapper'>
              <div>
                <Button
                  text='Back to briefing document'
                  variant={ButtonVariant.Secondary}
                  classNames='completedAssessmentButton'
                  onClick={() => navigate('/immersive/downloadPDF')}
                  transparent={true}
                  iconProps={{ path: IconName.mdiChevronLeft }}
                  alignIcon={ButtonIconAlign.Left}
                />
              </div>
              <div className='textContainer'>
                <h1 className='textHeading'>Ready to take the {immersiveAssessData?.prepData?.assessmentTitle}?</h1>
                <h2 className='textDescription'>Now that you've completed the preparation, you can take the assessment. Check out details and tips before getting started.</h2>
                <div className='assessmentActionItems'>
                  <Button
                    text={immersiveAssessData?.assessmentStatus === 'N' ? 'Launch Assessment' : 'Continue Assessment'}
                    variant={ButtonVariant.Secondary}
                    classNames='actionButton'
                    style={actionButtonStyle}
                    onClick={() => launchAssessmentWithStatusUpdate(immersiveAssessData, setShowLoader, dispatch)}
                    iconProps={showLoader ? { path: IconName.mdiLoading, spin: true } : { path: IconName.mdiArrowRight }}
                    alignIcon={ButtonIconAlign.Right}
                  />
                  <Button
                    text='Return to dashboard'
                    variant={ButtonVariant.Secondary}
                    classNames='navReturnButton'
                    style={navReturnBtnStyle}
                    onClick={() => {navigate('/dashboard')}}
                  />
                </div>
              </div>
            </div>

            <div className='rightTextWrapper'>
              <div className='bgImageWrapper' style={{backgroundImage: `url(./../assets/img/immersiveBackground.svg)`}}>
                <div className='contentOverlay'>
                  <div className='Textcontent'>
                    <div className='textSection'>
                      <h3 className='sectionHeading'>The pre work you completed</h3>
                      <div className='sectionDescription'>
                        <div className='sectionCard sectionCompleted' style={{ backgroundColor: '#f1f1f1',color: '#002136'}}>
                          <span className='iconWrapperCompleted'>
                          <Icon classNames='iconStyle' path={IconName.mdiCheck} size={IconSize.Small} style={{color:'#fff'}}/>
                          </span>
                          <div className='agilityCardTitle' style={{color:'#002136'}}>Watch informational video</div>
                          <div className='agilityCardDescription'>The short information video provides you with context about the entire immersive {immersiveAssessData?.prepData?.assessmentType?.toLowerCase()} experience.</div>
                        </div>
                        <div className='sectionCard' style={{ backgroundColor: '#f1f1f1',color: '#002136'}}>
                          <span className='iconWrapperCompleted'>
                            <Icon path={IconName.mdiCheck} size={IconSize.Small} style={{color:'#fff'}}/>
                          </span>
                          <div className='agilityCardTitle' style={{color:'#002136'}}>Download and review briefing document</div>
                          <div className='agilityCardDescription'>The document provides context for your simulation and will be crucial to your performance and decision-making during the experience.</div>
                        </div>
                      </div>
                    </div>

                    <div className='textSection'>
                      <h3 className='sectionHeading'>What to know before you start</h3>
                      <div className='sectionDescription'>
                        <div className='listSection'>
                          <div className='listTitle'>Time & Environment</div>
                          <div className='listItem'>
                            <Icon path={IconName.mdiClockOutline} size={IconSize.Small} />
                            <div className='listText'>Duration: <span>{immersiveAssessData?.prepData?.durationText}</span></div>
                          </div>
                          <hr className='listItemSeparator'/>

                          <div className='listItem'>
                            <img src={'../../assets/img/countOne.svg'} alt='count'/>
                            <div className='listText'>Must be completed <span>in one sitting</span></div>
                          </div>
                          <hr className='listItemSeparator'/>

                          <div className='listItem'>
                            <img src={'../../assets/img/mute.svg'} alt='mute'/>
                            <div className='listText'>Join from a <span>quiet location</span></div>
                          </div>
                        </div>

                        <div className='listSection'>
                          <div className='listTitle'>Technical Requirements</div>
                          <div className='listItem'>
                            <img src={'../../assets/img/desktop.svg'} alt='desktop'/>
                            <div className='listText'><span>Desktop/laptop</span> only</div>
                          </div>
                          <hr className='listItemSeparator'/>

                          <div className='listItem'>
                            <img src={'../../assets/img/microPhone.svg'} alt='microphone'/>
                            <div className='listText'>Working <span>microphone required</span></div>
                          </div>
                          <hr className='listItemSeparator'/>

                          <div className='listItem'>
                            <img src={'../../assets/img/headphones.svg'} alt='headphones'/>
                            <div className='listText'><span>Headphones recommended</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <AuthFooter />
        </div>
      </div>
    );
};

export default PrepStepsCompletion;